__turbopack_context__.v({
  "address": "ServerSection-module__ntzrNG__address",
  "bar": "ServerSection-module__ntzrNG__bar",
  "browser": "ServerSection-module__ntzrNG__browser",
  "chapter": "ServerSection-module__ntzrNG__chapter",
  "chip": "ServerSection-module__ntzrNG__chip",
  "cta": "ServerSection-module__ntzrNG__cta",
  "dots": "ServerSection-module__ntzrNG__dots",
  "eyebrow": "ServerSection-module__ntzrNG__eyebrow",
  "icons": "ServerSection-module__ntzrNG__icons",
  "note": "ServerSection-module__ntzrNG__note",
  "stage": "ServerSection-module__ntzrNG__stage",
  "text": "ServerSection-module__ntzrNG__text",
  "wrapper": "ServerSection-module__ntzrNG__wrapper",
});
